import { useState } from "react";
import { Link } from "react-router-dom";

const GOLD = "#00B4D8";
const BLACK = "#050505";
const GRAY = "#111";
const GRAY2 = "#1a1a1a";
const MUTED = "#666";
const WHITE = "#f5f5f0";

const WEBAPP_URL =
  "https://script.google.com/macros/s/AKfycbyUuYUfJBQRdl73HRGupkCYxvi87ovgB-HNgp44mnmNaxtQYCJH_TlGVMm10oodHlNu/exec";

const S = {
  root: {
    fontFamily: "'DM Sans', sans-serif",
    background: BLACK,
    color: WHITE,
    minHeight: "100vh",
    position: "relative",
    overflowX: "hidden",
  },
  bg: {
    position: "fixed",
    inset: 0,
    background:
      "radial-gradient(ellipse 55% 40% at 85% 5%,rgba(212,168,67,.08) 0%,transparent 60%),radial-gradient(ellipse 40% 50% at 5% 95%,rgba(212,168,67,.05) 0%,transparent 55%)",
    pointerEvents: "none",
    zIndex: 0,
  },
  hdr: {
    position: "relative",
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "24px 40px",
    borderBottom: "1px solid rgba(212,168,67,.15)",
  },
  lw: { display: "flex", alignItems: "center", gap: 12 },
  lt: {
    fontFamily: "'DM Sans', sans-serif",
    fontWeight: "bold",
    fontSize: 17,
    color: WHITE,
    letterSpacing: "-.3px",
  },
  ls: {
    fontSize: 10,
    letterSpacing: 3,
    textTransform: "uppercase",
    color: GOLD,
    fontFamily: "'DM Sans', sans-serif",
    fontWeight: 300,
    marginTop: 1,
  },
  bdg: {
    fontSize: 10,
    letterSpacing: 2,
    textTransform: "uppercase",
    color: MUTED,
    border: "1px solid rgba(212,168,67,.2)",
    padding: "5px 14px",
    borderRadius: 100,
    fontFamily: "'DM Sans', sans-serif",
  },
  homeLink: {
    fontSize: 13,
    color: MUTED,
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontFamily: "'DM Sans', sans-serif",
    transition: "color .2s",
  },
  hero: {
    position: "relative",
    zIndex: 5,
    padding: "56px 40px 40px",
    maxWidth: 820,
  },
  htag: {
    fontSize: 10,
    letterSpacing: 3,
    textTransform: "uppercase",
    color: GOLD,
    marginBottom: 16,
    fontFamily: "'DM Sans', sans-serif",
  },
  hh1: {
    fontSize: "clamp(30px,4.5vw,52px)",
    fontWeight: "bold",
    lineHeight: 1.08,
    letterSpacing: "-1px",
    color: WHITE,
    marginBottom: 16,
  },
  hsp: { color: GOLD },
  hp: {
    fontSize: 15,
    fontWeight: 300,
    color: MUTED,
    lineHeight: 1.7,
    maxWidth: 560,
    fontFamily: "'DM Sans', sans-serif",
  },
  pw: { position: "relative", zIndex: 5, padding: "0 40px 40px" },
  sr: { display: "flex", alignItems: "center", maxWidth: 480 },
  dot: (a, d) => ({
    width: 30,
    height: 30,
    borderRadius: "50%",
    border: `1.5px solid ${a ? GOLD : d ? GOLD : "rgba(212,168,67,.2)"}`,
    background: a ? GOLD : "transparent",
    color: a ? BLACK : d ? GOLD : MUTED,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: "bold",
    fontFamily: "'DM Sans', sans-serif",
    flexShrink: 0,
    transition: "all .3s",
  }),
  ln: (d) => ({
    flex: 1,
    height: 1,
    background: d ? GOLD : "rgba(212,168,67,.15)",
    transition: "background .3s",
  }),
  fw: { position: "relative", zIndex: 5, maxWidth: 740, margin: "0 40px 80px" },
  st: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    fontSize: 11,
    letterSpacing: 3,
    textTransform: "uppercase",
    color: GOLD,
    marginBottom: 28,
    fontFamily: "'DM Sans', sans-serif",
    fontWeight: "bold",
  },
  tl: { flex: 1, height: 1, background: "rgba(212,168,67,.15)" },
  g2: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 18,
    marginBottom: 18,
  },
  g1: { marginBottom: 18 },
  lbl: {
    display: "block",
    fontSize: 11,
    letterSpacing: 1.5,
    textTransform: "uppercase",
    color: MUTED,
    marginBottom: 8,
    fontFamily: "'DM Sans', sans-serif",
    fontWeight: 500,
  },
  req: { color: GOLD, marginLeft: 2 },
  inp: (f) => ({
    width: "100%",
    background: GRAY2,
    border: `1px solid ${f ? GOLD : "rgba(212,168,67,.18)"}`,
    borderRadius: 8,
    color: WHITE,
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 14,
    fontWeight: 300,
    padding: "13px 16px",
    outline: "none",
    boxShadow: f ? "0 0 0 3px rgba(212,168,67,.1)" : "none",
    transition: "border-color .2s,box-shadow .2s",
    boxSizing: "border-box",
  }),
  txta: (f) => ({
    width: "100%",
    background: GRAY2,
    border: `1px solid ${f ? GOLD : "rgba(212,168,67,.18)"}`,
    borderRadius: 8,
    color: WHITE,
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 14,
    fontWeight: 300,
    padding: "13px 16px",
    outline: "none",
    resize: "vertical",
    minHeight: 90,
    lineHeight: 1.6,
    boxShadow: f ? "0 0 0 3px rgba(212,168,67,.1)" : "none",
    transition: "border-color .2s,box-shadow .2s",
    boxSizing: "border-box",
  }),
  sel: (f) => ({
    width: "100%",
    background: GRAY2,
    border: `1px solid ${f ? GOLD : "rgba(212,168,67,.18)"}`,
    borderRadius: 8,
    color: WHITE,
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 14,
    fontWeight: 300,
    padding: "13px 16px",
    outline: "none",
    appearance: "none",
    cursor: "pointer",
    boxShadow: f ? "0 0 0 3px rgba(212,168,67,.1)" : "none",
    transition: "border-color .2s,box-shadow .2s",
    boxSizing: "border-box",
  }),
  nav: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 36,
  },
  bp: (d) => ({
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: 1,
    border: "none",
    cursor: d ? "not-allowed" : "pointer",
    padding: "13px 28px",
    borderRadius: 8,
    background: d ? "#444" : GOLD,
    color: d ? "#888" : BLACK,
    transition: "all .2s",
    opacity: d ? 0.7 : 1,
  }),
  bg2: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: 1,
    background: "transparent",
    color: MUTED,
    border: "1px solid rgba(212,168,67,.2)",
    cursor: "pointer",
    padding: "13px 28px",
    borderRadius: 8,
  },
  gw: {
    position: "relative",
    zIndex: 5,
    maxWidth: 740,
    margin: "0 40px 80px",
    textAlign: "center",
    padding: "80px 0",
  },
  gh3: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 22,
    fontWeight: "bold",
    color: WHITE,
    marginBottom: 10,
  },
  gp: { color: MUTED, fontSize: 14, fontFamily: "'DM Sans', sans-serif" },
  rw: { position: "relative", zIndex: 5, maxWidth: 740, margin: "0 40px 80px" },
  cd: {
    background: GRAY,
    border: "1px solid rgba(212,168,67,.18)",
    borderRadius: 16,
    padding: 36,
  },
  stag: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "rgba(52,168,83,.12)",
    border: "1px solid rgba(52,168,83,.35)",
    color: "#6ddb8a",
    fontSize: 10,
    letterSpacing: 2,
    textTransform: "uppercase",
    padding: "5px 14px",
    borderRadius: 100,
    marginBottom: 20,
    fontFamily: "'DM Sans', sans-serif",
  },
  dtag: (ok) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: ok ? "rgba(52,168,83,.12)" : "rgba(220,60,60,.1)",
    border: `1px solid ${ok ? "rgba(52,168,83,.35)" : "rgba(220,60,60,.3)"}`,
    color: ok ? "#6ddb8a" : "#f88",
    fontSize: 11,
    padding: "6px 14px",
    borderRadius: 100,
    marginTop: 10,
    fontFamily: "'DM Sans', sans-serif",
    letterSpacing: 1,
  }),
  err: {
    background: "rgba(220,60,60,.1)",
    border: "1px solid rgba(220,60,60,.3)",
    color: "#f88",
    borderRadius: 8,
    padding: "12px 16px",
    fontSize: 13,
    fontFamily: "'DM Sans', sans-serif",
    marginTop: 16,
  },
  ftr: {
    position: "relative",
    zIndex: 5,
    textAlign: "center",
    padding: "28px 40px",
    borderTop: "1px solid rgba(212,168,67,.1)",
    fontSize: 11,
    color: MUTED,
    letterSpacing: 1,
    fontFamily: "'DM Sans', sans-serif",
  },
  ftrLink: {
    color: MUTED,
    textDecoration: "none",
  },
};

if (!document.getElementById("_sf_css")) {
  const s = document.createElement("style");
  s.id = "_sf_css";
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&display=swap');
    @keyframes _sp{to{transform:rotate(360deg)}}
    ._sp{width:50px;height:50px;border:2px solid rgba(0,180,216,.2);border-top-color:#00B4D8;border-radius:50%;animation:_sp 1s linear infinite;margin:0 auto 24px}
    select option{background:#1a1a1a}
  `;
  document.head.appendChild(s);
}

function Fld({ label, req, children }) {
  return (
    <div>
      <label style={S.lbl}>
        {label}
        {req && <span style={S.req}>*</span>}
      </label>
      {children}
    </div>
  );
}
function Inp({ value, onChange, placeholder, type = "text" }) {
  const [f, setF] = useState(false);
  return (
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      style={S.inp(f)}
      onFocus={() => setF(true)}
      onBlur={() => setF(false)}
    />
  );
}
function Txt({ value, onChange, placeholder }) {
  const [f, setF] = useState(false);
  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      style={S.txta(f)}
      onFocus={() => setF(true)}
      onBlur={() => setF(false)}
    />
  );
}
function Sel({ value, onChange, options }) {
  const [f, setF] = useState(false);
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={S.sel(f)}
      onFocus={() => setF(true)}
      onBlur={() => setF(false)}
    >
      <option value="">Selecione…</option>
      {options.map((o) => (
        <option key={o} value={o}>
          {o}
        </option>
      ))}
    </select>
  );
}

export default function App() {
  const [step, setStep] = useState(1);
  const [phase, setPhase] = useState("form"); // form | sending | success
  const [err, setErr] = useState("");
  const [statusMsg, setStatusMsg] = useState("");

  const [f, setF] = useState({
    empresa: "",
    nome: "",
    whatsapp: "",
    email: "",
    site: "",
    segmento: "",
    produto: "",
    diferencial: "",
    ticket: "",
    tempo: "",
    publico: "",
    objetivo: "",
    concorrentes: "",
    canais: "",
    budget: "",
    urgencia: "",
    extras: "",
  });

  const upd = (k) => (v) => setF((p) => ({ ...p, [k]: v }));

  function validate() {
    if (step === 1 && (!f.empresa || !f.nome || !f.segmento)) {
      setErr("Preencha os campos obrigatórios: Empresa, Nome e Segmento.");
      return false;
    }
    if (step === 2 && !f.produto) {
      setErr("Descreva o produto ou serviço.");
      return false;
    }
    if (step === 3 && !f.publico) {
      setErr("Descreva o público-alvo.");
      return false;
    }
    setErr("");
    return true;
  }

  function next() {
    if (!validate()) return;
    setStep((s) => s + 1);
  }

  function back() {
    setErr("");
    setStep((s) => s - 1);
  }

  async function enviar() {
    if (!validate()) return;

    setPhase("sending");
    setErr("");
    setStatusMsg("");

    try {
      const res = await fetch(WEBAPP_URL, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
        body: JSON.stringify(f),
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        throw new Error(data.message || "Não foi possível enviar os dados.");
      }

      setStatusMsg(
        "Dados enviados com sucesso! Em breve você receberá atualizações no WhatsApp ou Email.",
      );
      setPhase("success");
    } catch (e) {
      setPhase("form");
      setErr(`Erro ao enviar: ${e.message}`);
    }
  }

  function reiniciar() {
    setStep(1);
    setPhase("form");
    setErr("");
    setStatusMsg("");
    setF({
      empresa: "",
      nome: "",
      whatsapp: "",
      email: "",
      site: "",
      segmento: "",
      produto: "",
      diferencial: "",
      ticket: "",
      tempo: "",
      publico: "",
      objetivo: "",
      concorrentes: "",
      canais: "",
      budget: "",
      urgencia: "",
      extras: "",
    });
  }

  return (
    <div style={S.root}>
      <div style={S.bg} />

      <header style={S.hdr}>
        <div style={S.lw}>
          <img src="/icon800.png" alt="Solution Factory" width={32} height={32} />
          <div>
            <div style={S.lt}>Solution Factory</div>
            <div style={S.ls}>Coleta de Briefing</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <Link to="/" style={S.homeLink}>← Home</Link>
          <div style={S.bdg}>Formulário Inteligente</div>
        </div>
      </header>

      {phase === "form" && (
        <>
          <div style={S.hero}>
            <div style={S.htag}>▸ Início do processo</div>
            <h1 style={S.hh1}>
              Conte-nos sobre
              <br />o seu <span style={S.hsp}>negócio</span>
            </h1>
            <p style={S.hp}>
              Responda algumas perguntas sobre a sua empresa que servirão como
              base dos processos de diagnóstico e estratégia de marketing.
            </p>
          </div>

          <div style={S.pw}>
            <div style={S.sr}>
              {[1, 2, 3, 4].map((n, i) => (
                <>
                  <div key={n} style={S.dot(step === n, step > n)}>
                    {step > n ? "✓" : n}
                  </div>
                  {i < 3 && <div key={`l${n}`} style={S.ln(step > n)} />}
                </>
              ))}
            </div>
          </div>

          <div style={S.fw}>
            {step === 1 && (
              <div>
                <div style={S.st}>
                  01 — Empresa & Contato
                  <div style={S.tl} />
                </div>
                <div style={S.g1}>
                  <Fld label="Nome da empresa" req>
                    <Inp
                      value={f.empresa}
                      onChange={upd("empresa")}
                      placeholder="Ex: Acme Ltda."
                    />
                  </Fld>
                </div>
                <div style={S.g1}>
                  <Fld label="Seu nome" req>
                    <Inp
                      value={f.nome}
                      onChange={upd("nome")}
                      placeholder="Nome do responsável"
                    />
                  </Fld>
                </div>
                <div style={S.g1}>
                  <Fld label="WhatsApp">
                    <Inp
                      value={f.whatsapp}
                      onChange={upd("whatsapp")}
                      placeholder="(11) 99999-9999"
                    />
                  </Fld>
                </div>
                <div style={S.g1}>
                  <Fld label="E-mail">
                    <Inp
                      value={f.email}
                      onChange={upd("email")}
                      placeholder="contato@empresa.com"
                      type="email"
                    />
                  </Fld>
                </div>
                <div style={S.g1}>
                  <Fld label="Instagram">
                    <Inp
                      value={f.site}
                      onChange={upd("site")}
                      placeholder="solutionfac"
                    />
                  </Fld>
                </div>
                <div style={S.g1}>
                  <Fld label="Segmento / Setor" req>
                    <Inp
                      value={f.segmento}
                      onChange={upd("segmento")}
                      placeholder="Ex: Logística, Saúde, Varejo…"
                    />
                  </Fld>
                </div>
                <p style={{ fontSize: 11, color: MUTED, lineHeight: 1.6, marginTop: 16, fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}>
                  Ao prosseguir você concorda com o tratamento de seus dados pela{" "}
                  <span style={{ color: GOLD }}>Solution Factory</span> com base na LGPD vigente.
                </p>
                {err && <div style={S.err}>{err}</div>}
                <div style={S.nav}>
                  <div />
                  <button style={S.bp(false)} onClick={next}>
                    Próximo →
                  </button>
                </div>
              </div>
            )}

            {step === 2 && (
              <div>
                <div style={S.st}>
                  02 — Sobre o Negócio
                  <div style={S.tl} />
                </div>
                <div style={S.g1}>
                  <Fld label="O que a empresa vende ou oferece?" req>
                    <Txt
                      value={f.produto}
                      onChange={upd("produto")}
                      placeholder="Descreva seus produtos/serviços…"
                    />
                  </Fld>
                </div>
                <div style={S.g1}>
                  <Fld label="Qual o grande diferencial?">
                    <Txt
                      value={f.diferencial}
                      onChange={upd("diferencial")}
                      placeholder="O que te faz único no mercado?"
                    />
                  </Fld>
                </div>
                <div style={S.g2}>
                  <Fld label="Ticket médio">
                    <Sel
                      value={f.ticket}
                      onChange={upd("ticket")}
                      options={[
                        "Até R$100",
                        "R$100 – R$500",
                        "R$500 – R$2.000",
                        "R$2.000 – R$10.000",
                        "Acima de R$10.000",
                      ]}
                    />
                  </Fld>
                  <Fld label="Tempo de mercado">
                    <Sel
                      value={f.tempo}
                      onChange={upd("tempo")}
                      options={[
                        "Menos de 1 ano",
                        "1 a 3 anos",
                        "3 a 5 anos",
                        "Mais de 5 anos",
                      ]}
                    />
                  </Fld>
                </div>
                {err && <div style={S.err}>{err}</div>}
                <div style={S.nav}>
                  <button style={S.bg2} onClick={back}>
                    ← Voltar
                  </button>
                  <button style={S.bp(false)} onClick={next}>
                    Próximo →
                  </button>
                </div>
              </div>
            )}

            {step === 3 && (
              <div>
                <div style={S.st}>
                  03 — Público & Objetivos
                  <div style={S.tl} />
                </div>
                <div style={S.g1}>
                  <Fld label="Quem é o cliente ideal?" req>
                    <Txt
                      value={f.publico}
                      onChange={upd("publico")}
                      placeholder="Idade, gênero, profissão, dores…"
                    />
                  </Fld>
                </div>
                <div style={S.g1}>
                  <Fld label="Objetivo principal">
                    <Sel
                      value={f.objetivo}
                      onChange={upd("objetivo")}
                      options={[
                        "Gerar mais leads / contatos",
                        "Aumentar vendas diretas",
                        "Fortalecer marca / autoridade",
                        "Lançar produto ou serviço",
                        "Fidelizar clientes existentes",
                        "Crescer nas redes sociais",
                      ]}
                    />
                  </Fld>
                </div>
                <div style={S.g1}>
                  <Fld label="Principais concorrentes">
                    <Inp
                      value={f.concorrentes}
                      onChange={upd("concorrentes")}
                      placeholder="Ex: Empresa A, Empresa B…"
                    />
                  </Fld>
                </div>
                {err && <div style={S.err}>{err}</div>}
                <div style={S.nav}>
                  <button style={S.bg2} onClick={back}>
                    ← Voltar
                  </button>
                  <button style={S.bp(false)} onClick={next}>
                    Próximo →
                  </button>
                </div>
              </div>
            )}

            {step === 4 && (
              <div>
                <div style={S.st}>
                  04 — Canais & Investimento
                  <div style={S.tl} />
                </div>
                <div style={S.g1}>
                  <Fld label="Canais digitais">
                    <Txt
                      value={f.canais}
                      onChange={upd("canais")}
                      placeholder="Ex: Instagram, Google Ads, WhatsApp…"
                    />
                  </Fld>
                </div>
                <div style={S.g2}>
                  <Fld label="Orçamento mensal">
                    <Sel
                      value={f.budget}
                      onChange={upd("budget")}
                      options={[
                        "Até R$1.500",
                        "R$1.500 – R$3.000",
                        "R$3.000 – R$6.000",
                        "R$6.000 – R$15.000",
                        "Acima de R$15.000",
                        "A definir",
                      ]}
                    />
                  </Fld>
                  <Fld label="Urgência">
                    <Sel
                      value={f.urgencia}
                      onChange={upd("urgencia")}
                      options={[
                        "Imediata (já!)",
                        "Próximo mês",
                        "Nos próximos 3 meses",
                        "Sem prazo definido",
                      ]}
                    />
                  </Fld>
                </div>
                <div style={S.g1}>
                  <Fld label="Informações adicionais">
                    <Txt
                      value={f.extras}
                      onChange={upd("extras")}
                      placeholder="Qualquer contexto extra…"
                    />
                  </Fld>
                </div>
                {err && <div style={S.err}>{err}</div>}
                <div style={S.nav}>
                  <button style={S.bg2} onClick={back}>
                    ← Voltar
                  </button>
                  <button style={S.bp(false)} onClick={enviar}>
                    Enviar dados
                  </button>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {phase === "sending" && (
        <div style={S.gw}>
          <div className="_sp" />
          <h3 style={S.gh3}>Enviando seus dados…</h3>
          <p style={S.gp}>Registrando as informações na planilha.</p>
        </div>
      )}

      {phase === "success" && (
        <div style={S.rw}>
          <div style={S.cd}>
            <div style={S.stag}>✓ Enviado com sucesso</div>
            <h3 style={S.gh3}>Cadastro concluído</h3>
            <p style={S.gp}>{statusMsg}</p>
            <div style={{ marginTop: 20 }}>
              <div style={S.dtag(true)}>
                ✓ Próximo passo: elaboração da etapa de Diagnóstico.
              </div>
            </div>
          </div>

          <div style={{ marginTop: 24, textAlign: "center" }}>
            <button style={S.bg2} onClick={reiniciar}>
              Preencher novo formulário
            </button>
          </div>
        </div>
      )}

      <footer style={S.ftr}>
        Desenvolvido por <span style={{ color: GOLD }}>Solution Factory</span> ·
        Direitos reservados. ·{" "}
        <Link to="/privacidade" style={S.ftrLink}>Política de Privacidade</Link> ·{" "}
        <Link to="/exclusao-de-dados" style={S.ftrLink}>Exclusão de Dados</Link>
      </footer>
    </div>
  );
}
